import React from 'react';
import styled from 'styled-components';
import { Check } from 'lucide-react';
import colors from 'theme/colors';

/**
 * Trilha do cadastro.
 *
 * A barra anterior era `valor * (lastStep * 10.5)`: o passo 1 nascia com 31,5%
 * preenchido e o último parava em 94,5%, sem nunca fechar. Além do número certo,
 * aqui os passos são nomeados — saber que o documento vem por último muda a
 * decisão de começar agora ou depois.
 */
export default function PartnerStepper({ steps, currentStep }) {
    const percent = (currentStep / steps.length) * 100;

    return (
        <Wrapper>
            <Track
                role='progressbar'
                aria-valuenow={currentStep}
                aria-valuemin={1}
                aria-valuemax={steps.length}
                aria-label={`Passo ${currentStep} de ${steps.length}: ${steps[currentStep - 1]?.label}`}
            >
                <Fill $percent={percent} />
            </Track>

            <List>
                {steps.map((step, index) => {
                    const position = index + 1;
                    const isDone = position < currentStep;
                    const isCurrent = position === currentStep;

                    return (
                        <Item
                            key={step.id}
                            $state={isDone ? 'done' : isCurrent ? 'current' : 'todo'}
                            aria-current={isCurrent ? 'step' : undefined}
                        >
                            <Bullet $state={isDone ? 'done' : isCurrent ? 'current' : 'todo'}>
                                {isDone ? <Check size={11} strokeWidth={3} aria-hidden='true' /> : position}
                            </Bullet>
                            <Label>{step.label}</Label>
                        </Item>
                    );
                })}
            </List>
        </Wrapper>
    );
}

const Wrapper = styled.div`
    width: 100%;
`;

const Track = styled.div`
    width: 100%;
    height: 6px;
    border-radius: 999px;
    background: #E4E4E8;
    overflow: hidden;
`;

const Fill = styled.div`
    height: 100%;
    width: ${({ $percent }) => $percent}%;
    border-radius: 999px;
    background: ${colors.secondaryPurple};
    transition: width 0.35s cubic-bezier(0.22, 1, 0.36, 1);
`;

const List = styled.ol`
    display: flex;
    justify-content: space-between;
    gap: 8px;
    list-style: none;
    margin: 10px 0 0;
    padding: 0;
`;

const Item = styled.li`
    display: flex;
    align-items: center;
    gap: 6px;
    min-width: 0;
    color: ${({ $state }) => ($state === 'todo' ? colors.nightLight : colors.nightDark)};
`;

const Bullet = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    font-size: 10px;
    font-weight: 600;

    ${({ $state }) => $state === 'done' && `
        background: ${colors.secondaryPurple};
        color: #fff;
    `}
    ${({ $state }) => $state === 'current' && `
        background: ${colors.secondaryPurple};
        color: #fff;
    `}
    ${({ $state }) => $state === 'todo' && `
        background: #E4E4E8;
        color: ${colors.night};
    `}
`;

const Label = styled.span`
    font-size: 11px;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;
